import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";

Vue.use(VueSweetalert2, {
  imageUrl: "assets/images/logo.png",
  imageWidth: 70,
  footer: "Si el problema persiste toma una captura y escríbenos, estaremos felices de ayudarte.",
  customClass: {
    container: "euSwal",
  },
  onOpen: () => {},
});
